export const feedTypes = {
  ALL: 'all',
  CREATORS: 'creators',
  PRODUCTS: 'products',
  RECIPES: 'recipes'
};

export default {};
